import React, { useState } from 'react'
import queryString from 'query-string'

import * as styles from './demo.module.css'

export const SignUpCta = ({ email }) => {
  const onCreateTrialClick = () => {
    const query = queryString.parseUrl(window.location.href).query
    const newQuery = queryString.stringify({ ...query, email })
    window.location.href = `${process.env.GATSBY_PROBE_APP_URL}/#/sign_up?${newQuery}`
  }

  return (
    <button
      onClick={onCreateTrialClick}
      type="submit"
      className={[styles.cta, styles.noMargin].join(' ')}
    >
      Create free trial
    </button>
  )
}

export const TalkWithFoundersCta = () => {
  const onScheduleDemo = () => {
    window.open('https://calendly.com/alex-getprobe-io/30min', '_blank')
  }

  return (
    <button
      onClick={onScheduleDemo}
      type="submit"
      className={[styles.cta, styles.noMargin].join(' ')}
    >
      Schedule demo
    </button>
  )
}

const SignUp = () => {
  const [email, setEmail] = useState('')

  const onEmailChange = e => {
    setEmail(e.target.value)
  }

  return (
    <div className={styles.signUp}>
      <input
        onChange={onEmailChange}
        className={styles.inputField}
        type="email"
        name="email"
        placeholder="your@email.com"
        required
      />
      <SignUpCta email={email} />
    </div>
  )
}

export default SignUp
